export interface InitSettings {
  cognitoSettings: CognitoSettings;
  layoutSettings: LayoutSettings;
}

export interface CognitoSettings {
  region: string;
  aws_project_region: string;
  aws_cognito_identity_pool_id: string;
  aws_cognito_region: string;
  aws_user_pools_id: string;
  aws_user_pools_web_client_id: string;

  oAuth?: OAuth;
  identityProviders?: IdentityProvider[];
}

export interface IdentityProvider {
  name: string;
  providerType: AuthProviderType;
  providerName?: string;
  defaultOrganisation?: string;
  color?: string;
  icon?: string;
}

export interface OAuth {
  domain: string;
  scope: string[];
}

export interface LayoutSettings {
  companyName: string;
  companyLogo: string;
}

export enum AuthProviderType {
  Cognito = "Cognito",
  OAuth = "OAuth",
}
